import React, { useEffect, useState } from "react";
import moment from "moment";
import { HotelSearchLoader } from "../list/components/HotelSearchLoader";
import "../../../assets/css/Hotel.css";
import { useGetHotelDetails } from "../hooks/useGetHotelDetails";
import { Loader } from "../list/components/Loader";
import { LocationIcon } from "../../../helper/HwIcon";
import { useHotelUtils } from "../hooks/useHotelUtils";
import {
  HotelDetailsReview,
  HotelReview,
} from "../list/components/HotelReview";
import { HotelOptions } from "./components/HotelOption";
import { SimilarProperties } from "./components/SimilarProperties";
import { HotelFacilities } from "./components/HotelFacilities";
import {
  HotelCancenlationPolicies,
  HotelPolicies,
} from "./components/HotelPolicies";
import { HotelPopularFacilities } from "./components/HotelPopularFacilities";
import { HotelLocation } from "./components/HotelLocation";
import { HotelGallery } from "./components/HotelGallery";
import { HotelSummary } from "./components/HotelSummary";
import { HotelSectionLinks } from "./components/HotelSectionLinks";
import { HotelSearchFormik } from "../search/components/HotelSearchFormik";
import { useGetListHotels } from "../hooks/useGetListHotels";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonPopup from "../../common-popup/CommonPopup";
import { formatPrice } from "../../../helper/commonFunction";
import HotelDetailSkeleton from "./components/HotelDetailSkeleton";
import { fromUrlVendor } from "../../../helper/vendorMask";

const HotelDetails = () => {
  const {
    filter,
  } = useGetListHotels(false);
  const { loading, details, searchQuery, onSelectRoom, checkoutLoading , checkoutErr , detailError , header } = useGetHotelDetails();
  const [showRoomInfoModal, setShowRoomInfoModal] = useState(false);
  const [loadingData,setloadingData]=useState(true)
  const [openNoData,setopenNoData]=useState(false)
  const [options,setOptions]=useState([])
  const {id} = useParams()
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const searchKeyword = query.get('keyword');
  const cityname = query.get('cityname');
  const isOwnHotel = fromUrlVendor(query.get('vendor')) === "DAHRTOURS";
  const roomLine = `${searchQuery?.roomInfo?.length} Rooms 
  ${searchQuery?.roomInfo?.reduce((acc, i) => {
    acc = acc + +i?.noOfAdult;
    return acc;
  }, 0)} 
  Adults ${searchQuery?.roomInfo?.reduce((acc, i) => {
    acc = acc + +i?.noOfChild;
    return acc;
  }, 0)} Child`;
  const data = details;
  const { ratings, images, scrollToDiv } = useHotelUtils(data?.hotelInfo);
  useEffect(()=>{
    window.scrollTo(0,0)
    if(data){
      setloadingData(false)
      let options = data?.hotelDetails?.hotels?.[0]?.options
      if(!options?.length > 0){
        setopenNoData(true)
      } else {
        let groupedOptions = {};
        options?.forEach((option) => {
          const cat = option?.rooomCategory;
          if (!groupedOptions[cat]) {
            groupedOptions[cat] = [option];
            return;
          }
          const dupKey = `${option?.mealValue || ""}`;
          const existingIdx = groupedOptions[cat].findIndex(
            (data) => `${data?.mealValue || ""}` === dupKey
          );
          if (existingIdx === -1) {
            groupedOptions[cat] = [...groupedOptions[cat], option];
          } else if (Number(option?.amount) < Number(groupedOptions[cat][existingIdx]?.amount)) {
            groupedOptions[cat][existingIdx] = option;
          }
        });
        const sortedOptions = Object.entries(groupedOptions).map(([category, rooms]) => {
          const sortedRooms = [...rooms].sort((a, b) => a?.amount - b?.amount)
          return [category, sortedRooms]
        })
        sortedOptions.sort((a, b) => {
          const minA = Math.min(...a[1].map(r => r?.amount));
          const minB = Math.min(...b[1].map(r => r?.amount));
          return minA - minB;
        });
        groupedOptions = Object.fromEntries(sortedOptions)
        setOptions(groupedOptions)
      }
    }
    if(detailError){
      setloadingData(false)
    }
  },[details,detailError])

  return (
    <>
      <div className="hw-hotes-module hw-hotel--widget hw-hotel--filterWidgetMain">
        <div className="hw-page--width" style={{pointerEvents : (loading || loadingData) ? "none" :""}}>
          <HotelSearchFormik
            searchUpdate={true}
            showRoomInfoModal={showRoomInfoModal}
            setShowRoomInfoModal={setShowRoomInfoModal}
            queryparams={{
              ...filter,
              cityValueExists: filter.city,
              city: undefined,
              // keyword: searchKeyword,
            }}
            hotelsList={[]}
            header={header}
          />
        </div>
      </div>
      {
        (loading || loadingData) ? <HotelDetailSkeleton/> : <div className={`hw-hotel--singleList hw-passenger--pageList`}>
        <div className="hw-page--width">
          <div className="hw-hotel--singleList__top mt-16">
            <button
              type="button"
              className="hw-hotel--backLink d-flex align-items-center hw-gapxy10 mb-2"
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#3264FF", fontWeight: 500 }}
              onClick={() => navigate(-1)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {`All properties${cityname ? ` in ${cityname}` : ""}`}
            </button>
            <div className="d-flex hw-gapy10 align-items-center mb-2">
              <h1 className="h3 mb-0">{data?.hotelInfo?.name}</h1>
              <div class="hw-hotel--stars">
                {ratings.map(() => (
                  <span class="filled">★</span>
                ))}
              </div>
            </div>
            <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
              <LocationIcon />
              {data?.hotelInfo?.address}
            </div>
          </div>
          <div className="mt-16">
            <div className="row hw-hotel--singleList__hotel">
              <HotelGallery images={images} />
              <HotelSummary data={data} rooms={searchQuery?.roomInfo?.length} roomLine={roomLine} scrollToDiv={scrollToDiv} searchContext={{...filter,id : id}} name={options}/>
            </div>
          </div>

          <div className="hw-hotel--singleListExtra">
            <HotelSectionLinks scrollToDiv={scrollToDiv} showSimilar={!isOwnHotel} />
            <div className="hw-hotel--singleListScrollerItem">
              <HotelPopularFacilities
                categories={data?.hotelInfo?.details?.amenities}
                facilities={data?.hotelInfo?.details?.amenityCategories}
                scrollToDiv={scrollToDiv}
              />
              <HotelOptions
                options={options}
                data={data}
                onSelectRoom={onSelectRoom}
                searchQuery={searchQuery}
                rooms={searchQuery?.roomInfo?.length}
                error={checkoutErr}
                images={images}
              />
              <HotelReview
                hotel={data?.hotelInfo}
                searchContext={{...filter,id:id}}
                component={(lable, avg, total, data, grouped) => {
                  return (
                    <HotelDetailsReview
                      data={data}
                      grouped={grouped}
                      total={total}
                      label={lable}
                      avg={avg}
                      hotelName={details?.hotelInfo?.name}
                    />
                  );
                }}
                searchCompleted={true}
              />

              <HotelLocation data={data} />
              <HotelFacilities data={data?.hotelInfo?.details?.amenityCategories} categories={data?.hotelInfo?.details?.amenities} />
              {(data?.hotelInfo?.details?.guestPolicies || data?.hotelInfo?.details?.otherPolicies || data?.hotelInfo?.details?.description) && <HotelPolicies details={data?.hotelInfo?.details} isOwn={isOwnHotel} />}
              {!isOwnHotel && <SimilarProperties hid={id} searchQuery={searchQuery} />}
            </div>
          </div>
        </div>
      </div>
      }

      {/* Room Selection Loader */}
      {checkoutLoading && (
        <HotelSearchLoader
          mode="checkout"
          city={data?.hotelInfo?.address || ""}
          inBig={searchQuery?.checkinDate ? moment(searchQuery.checkinDate).format("DD MMM") : ""}
          inDow={searchQuery?.checkinDate ? moment(searchQuery.checkinDate).format("dddd") : ""}
          outBig={searchQuery?.checkoutDate ? moment(searchQuery.checkoutDate).format("DD MMM") : ""}
          outDow={searchQuery?.checkoutDate ? moment(searchQuery.checkoutDate).format("dddd") : ""}
          nights={Math.max(1, moment(searchQuery?.checkoutDate).diff(moment(searchQuery?.checkinDate), 'days'))}
          rooms={searchQuery?.roomInfo?.length || 0}
          adults={searchQuery?.roomInfo?.reduce((acc, r) => acc + (+r?.noOfAdult || 0), 0) || 0}
          children={searchQuery?.roomInfo?.reduce((acc, r) => acc + (+r?.noOfChild || 0), 0) || 0}
        />
      )}

      <CommonPopup
        show={openNoData || detailError}
        title={detailError ? 'Alert' : 'No Rooms Available'}
        setShow={(_show) => {
          setopenNoData(_show);
          window.history.back()
        }}
      >
        <h1 className="hw-h2 mb-0 hw-text18" style={{textAlign : "center"}}>{detailError ? 'The hotel you’re looking for is no longer available or couldn’t be found. Please go back and choose another hotel.' : 'Rooms options are not available'}</h1>
      </CommonPopup>
    </>
  );
};
export default HotelDetails;